import React from 'react';

const SingleService = () => {
    return (
        <div>
            <h2>This signle page </h2>
        </div>
    );
};

export default SingleService;